<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Test Process Form Data Loading...
  </div>
  <div v-else class="animated fadeIn">
    <test-process-card v-if="test_process" :test_process="test_process" />
    <b-form @submit.prevent="onSubmit">
      <b-row class="mt-4">
        <b-col>
          <b-card no-body>
            <b-card-header>
              <span class="text-muted text-uppercase" >
                Test Process Identification
              </span>
            </b-card-header>
            <div class="py-3 px-5">
              <b-form-group label="Sample Type" :label-cols="2">
                <multiselect
                  v-model="selected_sample_type"
                  :value="sample_type_value"
                  :options="sample_type_options"
                  :multiple="false"
                  track-by="id"
                  label="name"
                />
              </b-form-group>
              <b-form-group label="Identifier" :label-cols="2">
                <b-form-input
                  type="text"
                  v-model="form_data.name"
                  placeholder="Process Name"
                />
              </b-form-group>
              <b-form-group label="Description" :label-cols="2">
                <b-form-textarea
                  v-model="form_data.description"
                  placeholder="Description"
                />
              </b-form-group>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-button
            @click="submitForm"
            class="my-4 float-right py-3 px-5"
            variant="success"
          >
            <i class="fal fa-address-book" /> Save
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect/src/Multiselect";
import TestProcessCard from "@/components/lab/testprocess/TestProcessCard";
import { getCollection } from "@/shared/fetch-utils";

export default {
  name: "TestProcessForm",
  components: {
    Multiselect,
    TestProcessCard,
  },
  props: {
    test_process: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      loading: true,
      form_data: {
        name: null,
        description: null,
        sample_type_id: null,
        test_tasks: []
      },
      sample_type_id: this.$route.params.sample_type_id || null,
      sample_type_collection: null,
      sample_type_options: [],
      sample_type_value: null,
    };
  },
  computed: {
    selected_sample_type: {
      get() {
        return this.sample_type_value;
      },
      set(value) {
        this.sample_type_value = value;
        this.form_data.sample_type_id = value && value.id;
      }
    },
  },
  methods: {
    initFormData() {
      if (this.test_process) {
        const { name, description, sample_type_id, test_tasks } = this.test_process;
        
        this.form_data = {
          name,
          description,
          sample_type_id,
          test_tasks: test_tasks.map(({ id }) => id)
        };

        this.sample_type_value = this.sample_type_options.find(({ id }) => id === sample_type_id);
      }
      
      if (this.sample_type_id) {
        this.form_data.sample_type_id = this.sample_type_id;
        this.sample_type_value = this.sample_type_options.find(({ id }) => id === this.sample_type_id);
      }
    },
    async init() {
      this.sample_type_collection = await getCollection({
        collection_type: "sample_type",
        message: this.$bvToast
      });

      this.sample_type_options = this.sample_type_collection.models.map(({ id, name }) => {
        return {
          id,
          name
        };
      });

      this.initFormData();

      this.loading = false;
    },
    submitForm() {
      this.$emit("submit", this.form_data);
    }
  },
  created() {
    this.loading = true;

    this.init();
  }
};
</script>
